import { render } from "./FreeForm.vue?vue&type=template&id=850ad256"
import script from "./FreeForm.vue?vue&type=script&lang=js"
export * from "./FreeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__